import React, { useMemo } from 'react';
import { Feeling } from '../../models/data';
import { useTranslation } from 'react-i18next';

import './FeelingItem.scss';

interface Props {
    feeling: Feeling;
    onClick: () => void;
    style?: any;
}

const FeelingItem: React.FC<Props> = ({ feeling, onClick, style = undefined }) => {
    const { t, i18n } = useTranslation();

    const feelingName = useMemo(() => {
        const labels = JSON.parse(JSON.parse(feeling.label));
        console.log('labels', labels);
        return labels[i18n.language] || labels['en'] || feeling.label;
    }, []);

    return (
        <div
            className="feelingItem"
            style={{
                ...style,
            }}
            onClick={() => onClick()}
        >
            <img src={feeling.img} alt={feeling.name} onError={({ currentTarget }) => (currentTarget.src = '')} />
            <p>{feelingName}</p>
        </div>
    );
};

export default FeelingItem;
